export default {
  path: 'insights',
  name: 'insights',
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "financial-insights" */ './Insights')
}
